import * as React from "react";
import {Video} from "@models/video-content";
import { Rate , Table} from "antd";
import {FormattedMessage, intlShape} from "react-intl";
import './index.scss'


type Props = {
  data: Video[];
  loading: boolean;
  deleteFn: (item: Video) => void;
  intl: intlShape.isRequired;
  currentPage: number;
};

const ReportList: React.FC<Props> = props => {
  const {data, loading} = props;
  
  const columns = [
    {
      title: <FormattedMessage id="app.index" defaultMessage={`Index`}/>,
      width: 30,
      dataIndex: "id",
      key: "id",
      render: (a, b, i) => <span>{i + 1 }</span>
    },
    {
      title: <FormattedMessage id="app.title" defaultMessage={`Title`}/>,
      align:"right",
      dataIndex: "title",
      key: "title",
    },
  
    {
      title: <FormattedMessage id="app.view_count" defaultMessage={`View Count`}/>,
      dataIndex: "view_count",
      align:"center",
      key: "view_count",
    },
    {
      title: <FormattedMessage id="app.average_view_in_hour" defaultMessage={`Average view in hour`}/>,
      dataIndex: "average_view_in_hour",
      key: "average_view_in_hour",
      align:"center",
      render: (value) => parseFloat(value.toFixed(2))
    },
    {
      title: <FormattedMessage id="app.rate_average" defaultMessage={`Rate average`}/>,
      dataIndex: "user_rate_average",
      key: "user_rate_average",
      align:"left",
      render: (value) => <div dir={'ltr'}><Rate disabled defaultValue={value/10} /></div>
    },
  ];
  
  return (
    <Table
      className={'report-table'}
      columns={columns}
      loading={loading}
      pagination={false}
      dataSource={data}
      rowKey="id"
    />
  );
};

export default ReportList;
